import { createPortal } from "react-dom";
import Modal from "../ui/Modal";
import { useLockBodyScroll } from "../../kyc/sections/common/common_utils/useLockBodyScroll";
import "./css/CorporateDocumentRequirementsEditor.css";

// Info modal: what each document type means and where the app uses it.
const DOC_TYPE_INFO = [
  {
    type: "Registration",
    proves: "The company exists and is registered: name, number, legal form, registered address, date of incorporation.",
    examples: "Register extract (Kbis, Handelsregisterauszug), certificate of incorporation, trade / commercial licence, Companies House printout",
    use: "Shown to clients in the start card and in the documents card.",
  },
  {
    type: "Good standing",
    proves: "The company is still active and in order today (not struck off, in liquidation or behind on fees).",
    examples: "Certificate of good standing, certificate of compliance, Companies House company certificate",
    use: "Shown with the registration documents, as they also evidence existence. Often the only current proof for offshore companies.",
  },
  {
    type: "Constitutional",
    proves: "How the company is organised and governed: purpose, share capital, powers of directors, signing rules.",
    examples: "Memorandum and / or articles of association, statuts, bylaws, operating agreement",
    use: "Not in the start card. Covered later by the setting “Registration + shareholder / constitutional documents”.",
  },
  {
    type: "Ownership",
    proves: "Who owns and runs the company: shareholders, directors, sometimes beneficial owners.",
    examples: "Register of members and directors, share register (Aktienbuch), share certificates, certificate of incumbency",
    use: "Not in the start card; same later setting. Usually optional, as a register extract often already shows management and sometimes shareholders.",
  },
];

// "Document types" info modal (Admin › Sources and organisation settings). Portaled to the body on its own
// layer, so it also opens above the organisation settings modal.
export default function CorporateDocumentTypesModal({ open, onClose }) {
  useLockBodyScroll(open);
  return createPortal(
    <div className="corpReqTypesLayer">
      <Modal open={open} onClose={onClose} className="corpReqTypesModal" title="Document types">
        <p className="corpReqTypesIntro">
          Each document has one main type. A document can also cover other types: its details (contains / equivalent to)
          show what else it evidences, e.g. a register extract that also lists the directors.
        </p>
        <div className="corpReqTypesTableWrap">
          <table className="corpReqTypesTable">
            <thead>
              <tr><th scope="col">Type</th><th scope="col">What it proves</th><th scope="col">Typical examples</th><th scope="col">Where it is used</th></tr>
            </thead>
            <tbody>
              {DOC_TYPE_INFO.map((row) => (
                <tr key={row.type}>
                  <th scope="row">{row.type}</th>
                  <td>{row.proves}</td>
                  <td>{row.examples}</td>
                  <td>{row.use}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Modal>
    </div>,
    document.body
  );
}
